import { convertMarkdownToHtml, displayDate, displayFullname } from '~/plugins/functions/display';

export interface IModelGETConversationAssociationConversationRequest {
  orderBy: string;
  orderType: string;
  count: boolean;
  page: number;
  limit: number;
  userId: number;
  presetId: number;
}

export interface IModelGETConversationAssociationConversationResponse {
  data: IModelGETConversationAssociationConversationDataResponse[];
  conversationUser: IModelGETConversationAssociationConversationUserResponse;
  totalItems: number;
}

export interface IModelGETConversationAssociationConversationDataResponse {
  id: string;
  presetId: string;
  userId: string;
  name: string;
  isArchived: boolean;
  archivedAt: string | Date | null;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  latestMessageAt: string | Date;
  preset: {
    name: string;
  }[];
}

export interface IModelGETConversationAssociationConversationUserResponse {
  accessKeyId: string;
  adminConsoleId: number;
  avatar: string;
  conversationCount: string;
  createdAt: string | Date;
  deletedAt: null | string | Date;
  email: string;
  id: number;
  inputToken: string;
  lastActiveAt: null | string | Date;
  lastLoginAt: null;
  originAppId: number;
  outputToken: string;
  password: string;
  phone: string;
  pinCode: null | string;
  presetName: string;
  secretAccessKeyId: string;
  secretExpiredAt: null | Date;
  status: string;
  updatedAt: string | Date;
  username: string;
}

export class ModelGETConversationAssociationConversation {
  dataList: ModelGETConversationAssociationConversationData[];
  conversationUser: ModelGETConversationAssociationConversationUser;
  totalItems: number;

  constructor(
    props = {} as IModelGETConversationAssociationConversationResponse
  ) {
    props =
      props ?? ({} as IModelGETConversationAssociationConversationResponse);
    this.dataList = (props.data || []).map(
      (e) => new ModelGETConversationAssociationConversationData(e)
    );
    this.conversationUser = new ModelGETConversationAssociationConversationUser(
      props.conversationUser
    );
    this.totalItems = props.totalItems || 0;
  }
}

export class ModelGETConversationAssociationConversationData {
  id: string;
  presetId: string;
  userId: string;
  name: string;
  isArchived: boolean;
  archivedAt: string | Date | null;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  latestMessageAt: string | Date;

  displayCreatedAt: string;
  displayUpdatedAt: string;
  displayLatestMessageAt: string;
  presetName: string;

  constructor(
    props = {} as IModelGETConversationAssociationConversationDataResponse
  ) {
    props =
      props ?? ({} as IModelGETConversationAssociationConversationDataResponse);
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.userId = props.userId || '';
    this.name = props.name || '';
    this.isArchived = props.isArchived || false;
    this.archivedAt = props.archivedAt || null;
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.latestMessageAt = props.latestMessageAt || '';

    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true,
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTime: true,
    });
    this.displayLatestMessageAt = displayDate(this.latestMessageAt, {
      isTime: true,
    });
    this.presetName = props.preset[0] ? props.preset[0].name : '-';
  }
}

export class ModelGETConversationAssociationConversationUser {
  accessKeyId: string;
  adminConsoleId: number;
  avatar: string;
  conversationCount: string;
  createdAt: string | Date;
  deletedAt: null | string | Date;
  email: string;
  id: number;
  inputToken: string;
  lastActiveAt: null | string | Date;
  lastLoginAt: null;
  originAppId: number;
  outputToken: string;
  password: string;
  phone: string;
  pinCode: null | string;
  presetName: string;
  secretAccessKeyId: string;
  secretExpiredAt: null | Date;
  status: string;
  updatedAt: string | Date;
  username: string;

  displayCreatedAt: string;
  displayAvatar: string;

  constructor(
    props = {} as IModelGETConversationAssociationConversationUserResponse
  ) {
    props =
      props ?? ({} as IModelGETConversationAssociationConversationUserResponse);
    this.accessKeyId = props.accessKeyId;
    this.adminConsoleId = props.adminConsoleId;
    this.avatar = props.avatar;
    this.conversationCount = props.conversationCount || '';
    this.createdAt = props.createdAt || '';
    this.deletedAt = props.deletedAt || null;
    this.email = props.email || '';
    this.id = props.id;
    this.inputToken = props.inputToken || '';
    this.lastActiveAt = props.lastActiveAt || null;
    this.lastLoginAt = props.lastLoginAt || null;
    this.originAppId = props.originAppId;
    this.outputToken = props.outputToken || '';
    this.password = props.password;
    this.phone = props.phone;
    this.pinCode = props.pinCode;
    this.presetName = props.presetName || '';
    this.secretAccessKeyId = props.secretAccessKeyId || '';
    this.secretExpiredAt = props.secretExpiredAt || null;
    this.status = props.status || '';
    this.updatedAt = props.updatedAt || '';
    this.username = props.username || '';

    this.displayCreatedAt = displayDate(this.createdAt);
    this.displayAvatar = '';
  }
}

// For DTO Conversation Archived

export interface IModelGETConversationAssociationConversationArchivedRequest {
  orderBy: string;
  orderType: string;
  count: boolean;
  page: number;
  limit: number;
  userId: number;
  presetId: number;
}

export interface IModelGETConversationAssociationConversationArchivedResponse {
  data: IModelGETConversationAssociationConversationArchivedDataResponse[];
  conversationUser: IModelGETConversationAssociationConversationArchivedConversationUserResponse;
  totalItems: number;
}

export interface IModelGETConversationAssociationConversationArchivedDataResponse {
  id: string;
  presetId: string;
  userId: string;
  name: string;
  isArchived: boolean;
  archivedAt: string | Date | null;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  preset: IModelGETConversationAssociationConversationArchivedDataPresetResponse[];
}

export interface IModelGETConversationAssociationConversationArchivedDataPresetResponse {
  name: string;
}

export interface IModelGETConversationAssociationConversationArchivedConversationUserResponse {
  accessKeyId: string;
  adminConsoleId: number;
  avatar: string;
  conversationCount: string;
  createdAt: string | Date;
  deletedAt: null | string | Date;
  email: string;
  id: number;
  inputToken: string;
  lastActiveAt: null | string | Date;
  lastLoginAt: null;
  originAppId: number;
  outputToken: string;
  password: string;
  phone: string;
  pinCode: null | string;
  presetName: string;
  secretAccessKeyId: string;
  secretExpiredAt: null | Date;
  status: string;
  updatedAt: string | Date;
  username: string;
}

export class ModelGETConversationAssociationConversationArchived {
  dataList: ModelGETConversationAssociationConversationArchivedData[];
  conversationUser: ModelGETConversationAssociationConversationArchivedConversationUser;
  totalItems: number;

  constructor(
    props = {} as IModelGETConversationAssociationConversationArchivedResponse
  ) {
    props =
      props ??
      ({} as IModelGETConversationAssociationConversationArchivedResponse);
    this.dataList = (props.data || []).map(
      (e: IModelGETConversationAssociationConversationArchivedDataResponse) =>
        new ModelGETConversationAssociationConversationArchivedData(e)
    );
    this.conversationUser =
      new ModelGETConversationAssociationConversationArchivedConversationUser(
        props.conversationUser
      );
    this.totalItems = props.totalItems;
  }
}

export class ModelGETConversationAssociationConversationArchivedData {
  id: string;
  presetId: string;
  userId: string;
  name: string;
  isArchived: boolean;
  archivedAt: string | Date | null;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  presetList: ModelGETConversationAssociationConversationArchivedDataPreset[];

  displayCreatedAt: string;
  displayArchivedAt: string;
  presetName: string;

  constructor(
    props = {} as IModelGETConversationAssociationConversationArchivedDataResponse
  ) {
    props =
      props ??
      ({} as IModelGETConversationAssociationConversationArchivedDataResponse);
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.userId = props.userId || '';
    this.name = props.name || '';
    this.isArchived = props.isArchived || false;
    this.archivedAt = props.archivedAt || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    // this.preset = new ModelGETConversationAssociationConversationArchivedDataPreset(props.preset);
    this.presetList = (props.preset || []).map(
      (e) =>
        new ModelGETConversationAssociationConversationArchivedDataPreset(e)
    );

    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true,
    });
    this.displayArchivedAt = displayDate(this.archivedAt, {
      isTime: true,
    });
    this.presetName = this.presetList[0] ? this.presetList[0].name : '-';
  }
}

export class ModelGETConversationAssociationConversationArchivedDataPreset {
  name: string;

  constructor(
    props = {} as IModelGETConversationAssociationConversationArchivedDataPresetResponse
  ) {
    props =
      props ??
      ({} as IModelGETConversationAssociationConversationArchivedDataPresetResponse);
    this.name = props.name || '';
  }
}

export class ModelGETConversationAssociationConversationArchivedConversationUser {
  accessKeyId: string;
  adminConsoleId: number;
  avatar: string;
  conversationCount: string;
  createdAt: string | Date;
  deletedAt: null | string | Date;
  email: string;
  id: number;
  inputToken: string;
  lastActiveAt: null | string | Date;
  lastLoginAt: null;
  originAppId: number;
  outputToken: string;
  password: string;
  phone: string;
  pinCode: null | string;
  presetName: string;
  secretAccessKeyId: string;
  secretExpiredAt: null | Date;
  status: string;
  updatedAt: string | Date;
  username: string;

  displayCreatedAt: string;
  displayAvatar: string;

  constructor(
    props = {} as IModelGETConversationAssociationConversationArchivedConversationUserResponse
  ) {
    props =
      props ??
      ({} as IModelGETConversationAssociationConversationArchivedConversationUserResponse);
    this.accessKeyId = props.accessKeyId;
    this.adminConsoleId = props.adminConsoleId;
    this.avatar = props.avatar;
    this.conversationCount = props.conversationCount || '';
    this.createdAt = props.createdAt || '';
    this.deletedAt = props.deletedAt || null;
    this.email = props.email || '';
    this.id = props.id;
    this.inputToken = props.inputToken || '';
    this.lastActiveAt = props.lastActiveAt || null;
    this.lastLoginAt = props.lastLoginAt || null;
    this.originAppId = props.originAppId;
    this.outputToken = props.outputToken || '';
    this.password = props.password;
    this.phone = props.phone;
    this.pinCode = props.pinCode;
    this.presetName = props.presetName || '';
    this.secretAccessKeyId = props.secretAccessKeyId || '';
    this.secretExpiredAt = props.secretExpiredAt || null;
    this.status = props.status || '';
    this.updatedAt = props.updatedAt || '';
    this.username = props.username || '';

    this.displayCreatedAt = displayDate(this.createdAt);
    this.displayAvatar = '';
  }
}

// For DTO PUT Conversation
export interface IModelPUTConversationRequest {
  id: string;
  isArchived: boolean;
}

export interface IModelOptionResponse {
  id: string;
  name: string;
  value: string;
}

export class ModelOption {
  id: string;
  name: string;
  value: string;

  // additional properties can be added here
  label?: string;

  constructor(props = {} as IModelOptionResponse) {
    this.id = props.id;
    this.name = props.name;

    this.value = props.value;
  }
}

export interface IModelDepartmentResponse {
  id: string;
  department: string;
  roomName: string;
  createdAt: string;
  updatedAt: string;
  isExist: boolean;
}

export class ModelDepartment {
  id: string;
  department: string;
  roomName: string;
  createdAt: string;
  updatedAt: string;
  isExist: boolean;

  constructor(props = {} as IModelDepartmentResponse) {
    this.id = props.id;
    this.department = props.department;
    this.roomName = props.roomName;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
    this.isExist = props.isExist || false;
  }
}

export interface IModelGETConversationFeedbackResponse {
  message: string;
  totalItems: number;
  data: IModelGETConversationFeedbackDataResponse[];
  conversationUser: IModelGETConversationFeedbackUserResponse;
}

export interface IModelGETConversationFeedbackGenImageResponse {
  fileName: string;
  filePath: string;
  fileSize: number;
  mimeType: string;
}

export interface IModelGETConversationFeedbackDataResponse {
  id: string;
  conversationId: string;
  parentId: string | null;
  branchId: number;
  versionPosition: number;
  versionTotal: number;
  status: string;
  humanMessage: string;
  aiMessage: string;
  files: any[];
  genImage: IModelGETConversationFeedbackGenImageResponse[];
  inputToken: string;
  outputToken: string;
  toolSearchWeb: boolean;
  isMaxToken: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
  softDeleted: boolean;
  thumbs: string;
  thumbsDownComment: string;
  model: string | null;
  sources: any[];
  errorId: string | null;
  errorMessage: string | null;
  errorStack: string | null;
  conversation: IModelGETConversationFeedbackConversationResponse;
}

export interface IModelGETConversationFeedbackConversationResponse {
  id: string;
  presetId: string;
  userId: string;
  name: string;
  isArchived: boolean;
  archivedAt: string | Date | null;
  presetActiveId: string;
  workflowActiveId: string | null;
  inputToken: string;
  outputToken: string;
  createdAt: string | Date;
  createdBy: string;
  updatedAt: string | Date;
  updatedBy: string;
  softDeleted: boolean;
  model: string | null;
  latestMessageAt: string | Date;
  preset: IModelGETConversationFeedbackPresetResponse[];
}

export interface IModelGETConversationFeedbackPresetResponse {
  id: string;
  name: string;
  description: string;
  modelName: string | null;
  tools: any | null;
  knowledgeBase: any | null;
  commandDetail: string;
  beginningMessage: string | null;
  toolSearchWeb: boolean;
  toolCanvas: boolean;
  toolDallEImage: boolean;
  toolCode: boolean;
  toolCodeText: string | null;
  versionCount: string;
  avatarFilePath: string;
  dbType: string | null;
  dbHost: string | null;
  dbPort: string | null;
  dbUsername: string | null;
  dbPassword: string | null;
  dbName: string | null;
  dbSchema: string | null;
  topKResult: string | null;
  documentChunkSize: string | null;
  documentChunkOverlap: string | null;
  recursionLimit: string | null;
  embeddingModelName: string | null;
  vectorStoreType: string;
  vectorStoreHash: string;
  status: string;
  versionInUse: boolean;
  versionIsLatest: boolean;
  versionKey: string;
  isDuplicatedForUpdate: boolean;
  duplicatedFromId: string;
  duplicatedPendingId: string | null;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  softDeleted: boolean;
  isExternal: boolean;
  vectorCollectionId: string;
  vectorCollectionReady: boolean;
  vectorCollectionLastApplyAt: string | Date;
  preset_active: IModelGETConversationFeedbackPresetActiveResponse;
}

export interface IModelGETConversationFeedbackPresetActiveResponse {
  id: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  presetId: string;
}

export interface IModelGETConversationFeedbackUserResponse {
  id: number;
  adminConsoleId: number;
  username: string;
  email: string;
  phone: string;
  password: string;
  pinCode: string | null;
  accessKeyId: string;
  secretAccessKeyId: string;
  status: string;
  avatar: string | null;
  secretExpiredAt: string | Date | null;
  lastLoginAt: string | Date | null;
  lastActiveAt: string | Date | null;
  originAppId: number;
  inputToken: string;
  outputToken: string;
  department: string;
  role: string;
  publicRoom: string;
  specificRoom: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt: string | Date | null;
  adminType: string | null;
  presetName: string;
  conversationCount: string;
}

export class ModelGETConversationFeedback {
  message: string;
  totalItems: number;
  dataList: ModelGETConversationFeedbackData[];
  conversationUser: ModelGETConversationFeedbackUser;

  constructor(props = {} as IModelGETConversationFeedbackResponse) {
    props = props ?? ({} as IModelGETConversationFeedbackResponse);
    this.message = props.message || '';
    this.totalItems = props.totalItems || 0;
    this.dataList = (props.data || []).map(
      (e) => new ModelGETConversationFeedbackData(e)
    );
    this.conversationUser = new ModelGETConversationFeedbackUser(props.conversationUser);
  }
}

export class ModelGETConversationFeedbackGenImage {
  fileName: string;
  filePath: string;
  fileSize: number;
  mimeType: string;

  constructor(props = {} as IModelGETConversationFeedbackGenImageResponse) {
    props = props ?? ({} as IModelGETConversationFeedbackGenImageResponse);
    this.fileName = props.fileName || '';
    this.filePath = props.filePath || '';
    this.fileSize = props.fileSize || 0;
    this.mimeType = props.mimeType || '';
  }
}

export class ModelGETConversationFeedbackData {
  id: string;
  conversationId: string;
  parentId: string | null;
  branchId: number;
  versionPosition: number;
  versionTotal: number;
  status: string;
  humanMessage: string;
  aiMessage: string;
  files: any[];
  genImageList: ModelGETConversationFeedbackGenImage[];
  inputToken: string;
  outputToken: string;
  toolSearchWeb: boolean;
  isMaxToken: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
  softDeleted: boolean;
  thumbs: string;
  thumbsDownComment: string;
  model: string | null;
  sources: any[];
  errorId: string | null;
  errorMessage: string | null;
  errorStack: string | null;
  conversation: ModelGETConversationFeedbackConversation;
  presetName: string;
  displayUpdatedAt: string;

  constructor(props = {} as IModelGETConversationFeedbackDataResponse) {
    props = props ?? ({} as IModelGETConversationFeedbackDataResponse);
    this.id = props.id || '';
    this.conversationId = props.conversationId || '';
    this.parentId = props.parentId || null;
    this.branchId = props.branchId || 0;
    this.versionPosition = props.versionPosition || 0;
    this.versionTotal = props.versionTotal || 0;
    this.status = props.status || '';
    this.humanMessage = props.humanMessage || '';
    this.files = props.files || [];
    this.genImageList = (props.genImage || []).map(
      (e) => new ModelGETConversationFeedbackGenImage(e)
    );
    
    // If aiMessage is empty but genImageList has items, display "Image"
    if (!props.aiMessage && this.genImageList.length > 0) {
      this.aiMessage = 'Image';
    } else {
      this.aiMessage = convertMarkdownToHtml(props.aiMessage || '');
    }
    
    this.inputToken = props.inputToken || '';
    this.outputToken = props.outputToken || '';
    this.toolSearchWeb = props.toolSearchWeb || false;
    this.isMaxToken = props.isMaxToken || false;
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
    this.softDeleted = props.softDeleted || false;
    this.thumbs = props.thumbs || '';
    this.thumbsDownComment = props.thumbsDownComment || '';
    this.model = props.model || null;
    this.sources = props.sources || [];
    this.errorId = props.errorId || null;
    this.errorMessage = props.errorMessage || null;
    this.errorStack = props.errorStack || null;
    this.conversation = new ModelGETConversationFeedbackConversation(props.conversation);

    this.presetName = this.conversation.presetList[0].name || '';
    this.displayUpdatedAt = displayDate(this.updatedAt);
  }
}

export class ModelGETConversationFeedbackConversation {
  id: string;
  presetId: string;
  userId: string;
  name: string;
  isArchived: boolean;
  archivedAt: string | Date | null;
  presetActiveId: string;
  workflowActiveId: string | null;
  inputToken: string;
  outputToken: string;
  createdAt: string | Date;
  createdBy: string;
  updatedAt: string | Date;
  updatedBy: string;
  softDeleted: boolean;
  model: string | null;
  latestMessageAt: string | Date;
  presetList: ModelGETConversationFeedbackPreset[];

  constructor(props = {} as IModelGETConversationFeedbackConversationResponse) {
    props = props ?? ({} as IModelGETConversationFeedbackConversationResponse);
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.userId = props.userId || '';
    this.name = props.name || '';
    this.isArchived = props.isArchived || false;
    this.archivedAt = props.archivedAt || null;
    this.presetActiveId = props.presetActiveId || '';
    this.workflowActiveId = props.workflowActiveId || null;
    this.inputToken = props.inputToken || '';
    this.outputToken = props.outputToken || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || '';
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || '';
    this.softDeleted = props.softDeleted || false;
    this.model = props.model || null;
    this.latestMessageAt = props.latestMessageAt || '';
    this.presetList = (props.preset || []).map(
      (e) => new ModelGETConversationFeedbackPreset(e)
    );
  }
}

export class ModelGETConversationFeedbackPreset {
  id: string;
  name: string;
  description: string;
  modelName: string | null;
  tools: any | null;
  knowledgeBase: any | null;
  commandDetail: string;
  beginningMessage: string | null;
  toolSearchWeb: boolean;
  toolCanvas: boolean;
  toolDallEImage: boolean;
  toolCode: boolean;
  toolCodeText: string | null;
  versionCount: string;
  avatarFilePath: string;
  dbType: string | null;
  dbHost: string | null;
  dbPort: string | null;
  dbUsername: string | null;
  dbPassword: string | null;
  dbName: string | null;
  dbSchema: string | null;
  topKResult: string | null;
  documentChunkSize: string | null;
  documentChunkOverlap: string | null;
  recursionLimit: string | null;
  embeddingModelName: string | null;
  vectorStoreType: string;
  vectorStoreHash: string;
  status: string;
  versionInUse: boolean;
  versionIsLatest: boolean;
  versionKey: string;
  isDuplicatedForUpdate: boolean;
  duplicatedFromId: string;
  duplicatedPendingId: string | null;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  softDeleted: boolean;
  isExternal: boolean;
  vectorCollectionId: string;
  vectorCollectionReady: boolean;
  vectorCollectionLastApplyAt: string | Date;
  presetActive: ModelGETConversationFeedbackPresetActive;

  constructor(props = {} as IModelGETConversationFeedbackPresetResponse) {
    props = props ?? ({} as IModelGETConversationFeedbackPresetResponse);
    this.id = props.id || '';
    this.name = props.name || '';
    this.description = props.description || '';
    this.modelName = props.modelName || null;
    this.tools = props.tools || null;
    this.knowledgeBase = props.knowledgeBase || null;
    this.commandDetail = props.commandDetail || '';
    this.beginningMessage = props.beginningMessage || null;
    this.toolSearchWeb = props.toolSearchWeb || false;
    this.toolCanvas = props.toolCanvas || false;
    this.toolDallEImage = props.toolDallEImage || false;
    this.toolCode = props.toolCode || false;
    this.toolCodeText = props.toolCodeText || null;
    this.versionCount = props.versionCount || '';
    this.avatarFilePath = props.avatarFilePath || '';
    this.dbType = props.dbType || null;
    this.dbHost = props.dbHost || null;
    this.dbPort = props.dbPort || null;
    this.dbUsername = props.dbUsername || null;
    this.dbPassword = props.dbPassword || null;
    this.dbName = props.dbName || null;
    this.dbSchema = props.dbSchema || null;
    this.topKResult = props.topKResult || null;
    this.documentChunkSize = props.documentChunkSize || null;
    this.documentChunkOverlap = props.documentChunkOverlap || null;
    this.recursionLimit = props.recursionLimit || null;
    this.embeddingModelName = props.embeddingModelName || null;
    this.vectorStoreType = props.vectorStoreType || '';
    this.vectorStoreHash = props.vectorStoreHash || '';
    this.status = props.status || '';
    this.versionInUse = props.versionInUse || false;
    this.versionIsLatest = props.versionIsLatest || false;
    this.versionKey = props.versionKey || '';
    this.isDuplicatedForUpdate = props.isDuplicatedForUpdate || false;
    this.duplicatedFromId = props.duplicatedFromId || '';
    this.duplicatedPendingId = props.duplicatedPendingId || null;
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
    this.isExternal = props.isExternal || false;
    this.vectorCollectionId = props.vectorCollectionId || '';
    this.vectorCollectionReady = props.vectorCollectionReady || false;
    this.vectorCollectionLastApplyAt = props.vectorCollectionLastApplyAt || '';
    this.presetActive = new ModelGETConversationFeedbackPresetActive(props.preset_active);
  }
}

export class ModelGETConversationFeedbackPresetActive {
  id: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  presetId: string;

  constructor(props = {} as IModelGETConversationFeedbackPresetActiveResponse) {
    props = props ?? ({} as IModelGETConversationFeedbackPresetActiveResponse);
    this.id = props.id || '';
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
    this.presetId = props.presetId || '';
  }
}

export class ModelGETConversationFeedbackUser {
  id: number;
  adminConsoleId: number;
  username: string;
  email: string;
  phone: string;
  password: string;
  pinCode: string | null;
  accessKeyId: string;
  secretAccessKeyId: string;
  status: string;
  avatar: string | null;
  secretExpiredAt: string | Date | null;
  lastLoginAt: string | Date | null;
  lastActiveAt: string | Date | null;
  originAppId: number;
  inputToken: string;
  outputToken: string;
  department: string;
  role: string;
  publicRoom: string;
  specificRoom: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt: string | Date | null;
  adminType: string | null;
  presetName: string;
  conversationCount: string;

  constructor(props = {} as IModelGETConversationFeedbackUserResponse) {
    props = props ?? ({} as IModelGETConversationFeedbackUserResponse);
    this.id = props.id;
    this.adminConsoleId = props.adminConsoleId;
    this.username = props.username || '';
    this.email = props.email || '';
    this.phone = props.phone || '';
    this.password = props.password || '';
    this.pinCode = props.pinCode || null;
    this.accessKeyId = props.accessKeyId || '';
    this.secretAccessKeyId = props.secretAccessKeyId || '';
    this.status = props.status || '';
    this.avatar = props.avatar || null;
    this.secretExpiredAt = props.secretExpiredAt || null;
    this.lastLoginAt = props.lastLoginAt || null;
    this.lastActiveAt = props.lastActiveAt || null;
    this.originAppId = props.originAppId;
    this.inputToken = props.inputToken || '';
    this.outputToken = props.outputToken || '';
    this.department = props.department || '';
    this.role = props.role || '';
    this.publicRoom = props.publicRoom || '';
    this.specificRoom = props.specificRoom || '';
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
    this.deletedAt = props.deletedAt || null;
    this.adminType = props.adminType || null;
    this.presetName = props.presetName || '';
    this.conversationCount = props.conversationCount || '';
  }
}